"use strict";
import 'owl.carousel';
import 'lazysizes';
import tingle from 'tingle.js';
import { CountUp } from 'countup.js'
import 'waypoints/lib/noframework.waypoints.min';


(function($){

  if(window.innerWidth > 767) {
    function countStart(){
      const $counters = document.querySelectorAll(".js-count-up"),
        options = {
          useEasing: true,
          useGrouping: true,
          separator: ",",
          decimal: "."
        };

      $counters.forEach( (item) => {
        const value = item.dataset.value;
        const counter = new CountUp(item, value, options);
        counter.start();
      });
    }

    if(document.querySelector('.global-operations-summary-widget')){
      new Waypoint({
        element: document.querySelector('.global-operations-summary-widget'),
        handler: function() {
          countStart()
          //this.destroy() //for once
        },
        offset: '50%'
      });
    }
  }


    jQuery.event.special.touchstart = {
        setup: function( _, ns, handle ) {
            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };

    jQuery.event.special.wheel = {
        setup: function( _, ns, handle ){
            this.addEventListener("wheel", handle, { passive: true });
        }
    };
    jQuery.event.special.mousewheel = {
        setup: function( _, ns, handle ){
            this.addEventListener("mousewheel", handle, { passive: true });
        }
    };

    jQuery(document).ready(function($) {
        if ($(window).width() > 768){
            $('body').on('click', function (e) {
                let c = $('.header_top_lang_switcher');
                if (!c.is(e.target) && c.has(e.target).length === 0) {
                    $('.header_top_lang_drop').fadeOut();
                    c.removeClass('active');
                }

                let c2 = $('.header_top_nav ul li.popular_airports>a');
                if (!c2.is(e.target) && c2.has(e.target).length === 0) {
                    $('.popular_airports_wr').fadeOut();
                    c2.removeClass('active');
                }
            });
        }
        $('.header_top_lang_switcher').click(function(e) {
            e.preventDefault();
            $('.header_top_lang_drop').fadeToggle();
            $(this).toggleClass('active');
        });
        $(".header_top_nav .popular_airports_item_ul li a").mouseenter(function() {
            var id = $(this).attr('id').replace('key_','');
            var el = $('.popular_airports_info[id=key_content_'+id+']');
            var timeoutId = setTimeout(function() {
                el.fadeIn('fast');
            }, 200);
            $(this).mouseleave(function() {
                clearTimeout(timeoutId);
                el.fadeOut('fast');
            });
        });
        $('.header_top_nav ul li.popular_airports>a').click(function(e) {
            e.preventDefault();
            $('.popular_airports_wr').fadeToggle();
            $(this).toggleClass('active');
        });
        $(".popular_slider .popular_airports_item_ul li a").mouseenter(function() {
            $(this).parentsUntil(".owl-stage").css( "z-index", "2" );
            var el = $(this).parent().find('.popular_airports_info');
            var timeoutId = setTimeout(function() {
                el.fadeIn('fast');
            }, 200);
            $(this).mouseleave(function() {
                clearTimeout(timeoutId);
                el.fadeOut('fast');
                $(this).parentsUntil(".owl-stage").css( "z-index", "auto" );
            });
        });
        $('.popular_nav').on('click', '.popular_nav_btn:not(.active)', function() {
            $(this)
                .addClass('active').siblings().removeClass('active')
                .closest('.popular').find('div.popular_slider').removeClass('active').eq($(this).index()).addClass('active');
        });
        $('.single_services_ul>ul>li>a').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).parent().find('.single_services_child').toggleClass('active');
        });
        $('.faq_item').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active').find('div').fadeToggle();
        });
        $('.popular_locations_btn').on('click', function() {
            $('.popular_locations_menu, .about_single_left').toggleClass('active');
            $('.about_single_pt').fadeToggle();
            $(this).toggleClass('less');
            $(this).text(function(i, text){
                return text === "Read more" ? "Read less" : "Read more";
            });
        });
        $('.contact_content_nav ul li').click(function(){
            $('.contact_content_nav ul li').removeClass('active');
            $(this).addClass('active');
        });
        $('.hamburger').click(function() {
            $('.hamburger').toggleClass('is-active');
            $('.header_mbmenu').fadeToggle('fast', 'linear', function () {
	            if($('.header_mbmenu').css('display') === 'block') {
		            $('body').addClass('nav-menu-opened')
	            }else {
		            $('body').removeClass('nav-menu-opened')
	            }
            });
        });

			function loadYTVideo(id) {
				id = id ? id : $("body").data("video-id")
				modalVideo.setContent('<div class="popup-escape-safe popup-escape">' +
					'<i class="fa fa-times"></i>' +
					'</div><div id="player">' +
					'<iframe width="560" height="315" ' +
					'src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&loop=1&playlist=' + id + '" ' +
					'frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ' +
					'autoplay allowfullscreen></iframe></div><style>#player iframe{max-width:100%;}</style>')
				modalVideo.open();
			}
			function loadJS(id) {
				var tag = document.createElement('script');
				tag.src = "//www.youtube.com/iframe_api";
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
				$("body").data("video-id", id)
			}
			$("#video").on("click", function(e) {
				$(this).addClass("loading");
				e.preventDefault();
				loadYTVideo($(this).data('video-id'))
			});
			if ($('#book-safety').length || $('#welcome_video').length) {
				var modalVideo = new tingle.modal({
					footer: false,
					stickyFooter: false,
					cssClass: ["video", "safe"],
					onOpen: function() {
						$(".popup-escape-safe").on("click", function() {
							modalVideo.close();
						});
					},
					onClose: function() {
						modalVideo.setContent('');
						$("#video").removeClass("loading")
						$("#background-element").find('span.icon-sprite').removeClass("loading")
					}
				});
				var modalSafe = new tingle.modal({
					footer: false,
					stickyFooter: false,
					cssClass: ["safe"],
					onOpen: function() {
						$(".popup-escape-safe").on("click", function() {
							modalSafe.close();
						});
					}
				});
				$(".safety-bar--btn,#book-safety").on("click", function(e) {
					e.preventDefault()
					var url = $(this).attr('data-url');
					var typeOveflow = $(window).width() > 767 ? "hidden" : "auto";
					modalSafe.setContent("<div class='modal-head'><div class='popup-escape-safe popup-escape'>" +
						"<i class='fa fa-times'></i></div></div>" +
						"<div style='margin:0px;padding:0 25px;height:80vh;overflow:" + typeOveflow + ";-webkit-overflow-scrolling: touch;'>" +
						"<iframe width='100%'  scrolling='yes' seamless='seamless' frameborder='0' height='100%' src='" + url + "'></iframe></div>");
					modalSafe.open();
				});
			}

      if($('.wrap_testimonials_add a').length) {
        let testimonialWr = $('.wrap_testimonials_add');
        var testimonialModal = new tingle.modal({
          footer: true,
          stickyFooter: true,
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: "Close",
          cssClass: ['testimonial-modal'],
          onOpen: function() {
            $(".popup-escape-safe").on("click", function() {
              testimonialModal.close();
            });
          },
        });

        var typeOveflow = $(window).width() > 767 ? "hidden" : "auto";
        testimonialModal.setContent("<div class='modal-head'>" + testimonialWr.data('title') + "</div>" +
          "<div class='testimonial-modal-content' style='overflow:" + typeOveflow + ";-webkit-overflow-scrolling: touch;'>" +
          "<form>" +
          "<label for='author'><span class='required'>*</span>"+testimonialWr.data('your-name')+"</label>" +
          "<input type='text' id='author' name='author'>" +
          "<label for='rating'><span class='required'>*</span>"+testimonialWr.data('your-rating')+"</label>" +
          "<select name='rating' id='rating'>" +
            "<option value='5'>5 Stars</option>" +
            "<option value='4'>4 Stars</option>" +
            "<option value='3'>3 Stars</option>" +
            "<option value='2'>2 Stars</option>" +
            "<option value='1'>1 Star</option>" +
          "</select>" +
          "<label for='content'><span class='required'>*</span>"+testimonialWr.data('your-feedback')+"</label>" +
          "<textarea type='text' id='content' name='content'></textarea>" +
          "<div id='recaptcha' class='g-recaptcha' data-sitekey='"+testimonialWr.data('captcha-key')+"' data-size='invisible'></div>" +
		      "<div id='res_message' class=''>/</div>" +
          "</form>" +
          "</div>"
        );

        testimonialModal.addFooterBtn(testimonialWr.data('send'), 'tingle-btn tingle-btn--primary', function() {
          sendNewReview();
        });

        // add another button
        testimonialModal.addFooterBtn(testimonialWr.data('cancel'), 'tingle-btn tingle-btn--danger', function() {
          testimonialModal.close();
        });
        $('.wrap_testimonials_add a').on('click', function(event){
          event.preventDefault();
          testimonialModal.open();
        });

        function sendNewReview() {
          let form = $('.testimonial-modal form');

          grecaptcha.ready(() => {
            grecaptcha.execute().then(token => {
              form.find('#g-recaptcha-response').val(token);

              $.ajax({
                type: "POST",
                url: testimonialWr.data('url'),
                data: form.serialize(),
                beforeSend: function () {
                  form.find('.error').removeClass('error');
                  form.addClass('preload');
                },
                success: function (data) {
                  form.removeClass('preload');
                  let res = data;
                  if (typeof res.message !== 'undefined') {
                    form.find('#res_message').html(res.message);
                    form.find('#res_message').attr('class', 'success');
                  }
                  form.trigger('reset');
                },
                error: function (e) {
                  form.removeClass('preload');
                  let res = e.responseJSON;
                  if (typeof res.message !== 'undefined') {
                    form.find('#res_message').html(res.message);
                    form.find('#res_message').attr('class', 'error');
                  }
                  if (typeof res.errors !== 'undefined') {
                    for (var i in res.errors) {
                      form.find('[name="' + i + '"]').addClass('error')
                    }
                  }
                }
              });
            })
          });

        }
      }


      $('.reviews-carousel').owlCarousel({
        loop:true,
        margin:20,
        autoWidth: true,
        center: true,
        dots: false,
        nav:true,
        responsive:{
          0:{
            center:true,
            margin:10,
            loop:true,
            startPosition: 1,
          },
          768:{
            center: true,
            loop:true,
            margin:20,
          }
        }
      });

      $('.testimonial-card-group').owlCarousel({
        loop:true,
        margin:20,
        autoWidth: true,
        center: true,
        dots: false,
        nav:true,
        responsive:{
          0:{
            center:true,
            margin:10,
            loop:true,
            startPosition: 1,
          },
          768:{
            center: true,
            loop:true,
            margin:20,
          }
        }
      });



      $('.vehicles-list').owlCarousel({
        loop:true,
        items: 5,
        margin:30,
        autoWidth: true,
        center: true,
        dots: false,
        nav:true,
        responsive:{
          0:{
            items:1,
            margin:10,
          },
          1200:{
            items: 5,
            margin:30,
          },
          768:{
            items: 3,
            margin:20,
            center: true,
          }
        }
      });

      $('.hero-carousel').owlCarousel({
        loop:false,
        items: 1,
        dots: false,
        nav:true,
      });


      $('.cars_carousel .cars_home_wr').owlCarousel({
        loop:false,
        items: 4,
        margin:20,
        dots: false,
        nav:true,
        responsive:{
          0:{
            items:1,
            margin:10,
          },
          1200:{
            items: 4,
            margin:20,
          },
          768:{
            items: 2,
            margin:20,
          }
        }
      });


        $('.popular_slider').owlCarousel({
            items: 4,
            margin:40,
            autoWidth: true,
            dots: false,
            nav:true
        });
        $('.popular_countries').owlCarousel({
            items: 3,
            margin:40,
            autoWidth: true,
            dots: false,
            nav:true,
            responsive:{
                0:{
                    items:1,
                    margin:20,
                },
                768:{
                    items: 3,
                    margin:40,
                }
            }
        });
        if($(window).width() < 768){
            $('.contact_content_nav ul li').first().removeClass('active');
            $(document).mouseup(function(e){
                const container = $(".contact_content_nav ul");
                if(!container.is(e.target) && container.has(e.target).length === 0){
                    $(".contact_content_nav ul li").removeClass('active');
                }
            });
            $(".popular_slider").trigger('destroy.owl.carousel');
            $('.single_airports').owlCarousel({
                items: 1,
                margin:10,
                autoWidth: true,
                dots: false,
                nav:true
            });
        }
        if($(window).width() < 768){
            $('.contact_content_nav ul li').click(function () {
                let id = $(this).attr('id');
                $('.contact_content_menu .contact_content_menu_item').each(function(e, i){
                    $(this).removeClass('active');
                })
                $('.contact_content_menu #'+id+'_content').addClass('active');
            });
            // $(".we_offer_menu").owlCarousel({
            //     margin:0,
            //     dots: false,
            //     items:1,
            //     loop:false,
            //     nav:true,
            //     startPosition: 1,
            // });
        }
        else {
            $(".we_offer_menu").trigger('destroy.owl.carousel');
            $('.contact_content_nav ul li').click(function () {
                let id = $(this).attr('id');
                $('.contact_content_menu .contact_content_menu_item').each(function(e, i){
                    $(this).removeClass('active');
                })
                $('.contact_content_menu #'+id+'_content').addClass('active');
            });
        }
        $('.popular_airports_item_name').on('click', function() {
            if($(this).parents('.locations-page').length && $(window).width() > 768) {
            }else{
                $(this).toggleClass('active');
                $(this).parent().find('.popular_airports_item_ul').fadeToggle();
            }
        });
        if($('.locations-page').length && $(window).width() < 768){
            $('.locations-page').find('.popular_slider_item').each( (i, el) => {
                if(i){
                    $(el).find('.we_offer_menu').hide();
                    $(el).find('.popular_airports_item_name').addClass('active');
                }
            })
        }
        $('.popular_airports_btn').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).parent().find('.popular_airports_menu').fadeToggle();
        });

        //Contact form
        var csrf_token = $('meta[name="csrf-token"]').attr('content');
        $.ajaxPrefilter(function(options, originalOptions, jqXHR){
            if (options.type.toLowerCase() === "post") {
                // initialize `data` to empty string if it does not exist
                options.data = options.data || "";

                // add leading ampersand if `data` is non-empty
                options.data += options.data?"&":"";

                // add _token entry
                options.data += "_token=" + encodeURIComponent(csrf_token);
            }
        });
        $('.contact_form_right form').on('submit', function(event) {
            event.preventDefault();
            grecaptcha.ready(() => {
                grecaptcha.execute().then(token => {
                    jQuery('.contact_form_right .g-recaptcha-response').val(token);
                    var form = $(this);
                    var url = form.attr('action');
                    //form.find('[name=token]').val(token);
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: form.serialize(),
                        beforeSend: function () {
                            $('.contact_form_right form').find('.error').removeClass('error');
                        },
                        success: function (data) {
                            let res = data;
                            if (typeof res.message !== 'undefined') {
                                $('.contact_form_right form #res_message').html(res.message);
                                $('.contact_form_right form #res_message').attr('class', 'success');
                            }
                            form.trigger('reset');
                        },
                        error: function (e) {
                            let res = e.responseJSON;
                            if (typeof res.message !== 'undefined') {
                                $('.contact_form_right form #res_message').html(res.message);
                                $('.contact_form_right form #res_message').attr('class', 'error');
                            }
                            if (typeof res.errors !== 'undefined') {
                                for (var i in res.errors) {
                                    console.log($('.contact_form_right form [name="' + i + '"]'));
                                    $('.contact_form_right form [name="' + i + '"]').addClass('error')//.append('<span class="error">'+res.errors[i]+'</span>');
                                }
                            }
                        }
                    });
                })
            });
        })
    });


})(jQuery)

